// extracted by mini-css-extract-plugin
export default {"footer":"CommunityFooter_footer__9Runh"};